module.exports = __webpack_public_path__ + "media/img/frontend_application/filter-icon-7e2ccaa36019f3d9a8ba7deaa87ad2c9.png";